import { BaseURL } from "../../utils/Network";
import { GuildPlayerStateEnum } from "./types";

export const DEFAULT_GUILD_HALL = "/assets/images/backgrounds/guild-hall.jpg";
export const DEFAULT_GUILD_CREST = "/assets/images/avatar-bg-1.png";

// Guild art comes back as a path on the game server, or already as a full URL.
export function guildAsset(path: string | null | undefined, fallback: string): string {
  if (!path) return fallback;
  return path.includes("chainoflegends") ? path : BaseURL + path;
}

export type GuildMember = {
  joinDate: string;
  state: number;
  playerId: number;
  username: string;
  score: number;
  photoFile: string;
  rank: number;
};

const ROSTER = [
  { title: "Lord", state: GuildPlayerStateEnum.Owner },
  { title: "Commanders", state: GuildPlayerStateEnum.Admin },
  { title: "Sergeants", state: GuildPlayerStateEnum.Member },
  { title: "Waiting to Join", state: GuildPlayerStateEnum.JoinRequest },
];

// The roster in order of command, best ranked first inside each group. Empty groups are left out.
export function groupMembers(members: GuildMember[] | undefined) {
  return ROSTER.map(({ title, state }) => ({
    title,
    state,
    members: (members || []).filter((member) => member.state === state).sort((a, b) => a.rank - b.rank),
  })).filter((group) => group.members.length > 0);
}

export const isSeated = (member: GuildMember) => member.state <= GuildPlayerStateEnum.Member;
